import React, { useCallback, useState, useRef } from "react";
import { useApp } from "@lib/providers";
import { DispatchContainer, TopRow, Label, TimeWrapper, Message, ReplayButton } from "./styles";
import * as T from "@types";
import { format } from "date-fns";
import { Api } from "@lib/utils";
import TranscriptLine from "./TranscriptLine";
// @ts-ignore
import ReplayIcon from "@assets/icons/replay.svg";

export const Transcription = ({ transcription }: T.TranscriptionProps) => {
  const { darkMode, config } = useApp();

  const [audioSrc, setAudioSrc] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [audioLoaded, setAudioLoaded] = useState(false);
  const audioRef = useRef();

  const playTranscript = useCallback(async () => {
    if (audioLoaded) {
      audioRef.current?.play();
      return;
    }
    const audioBlob = await Api.getAudio({
      id: transcription.message.data.channelId,
      audioId: transcription.message.data.id
    });
    const audioUrl = URL.createObjectURL(audioBlob);

    setAudioSrc(audioUrl);
    setAudioLoaded(true);
    setPlaying(true);
  }, [transcription]);

  const channelName = config.channels[transcription.message.data.channelId]?.name || "";

  return (
    <DispatchContainer darkMode={darkMode}>
      <TopRow>
        <Label darkMode={darkMode}>{channelName}</Label>
        <TimeWrapper darkMode={darkMode}>
          <ReplayButton darkMode={darkMode}>
            <ReplayIcon onClick={playTranscript} />
            {playing && audioSrc && <audio src={audioSrc} ref={audioRef} autoPlay={true} />}
          </ReplayButton>
          {format(transcription.message.data.sourceDate, "HH:mm:ss")}
        </TimeWrapper>
      </TopRow>
      <Message darkMode={darkMode}>
        <TranscriptLine segments={transcription.message.data.transcriptionSegments} />
      </Message>
    </DispatchContainer>
  );
};
